<template>
  <font-awesome-icon class="fa-icons" :icon="['far', 'comment']"></font-awesome-icon>
</template>
